<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
                岗位支援申请-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
                <!-- 查询框 -->
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="组织架构" prop="spare5" style="margin-top:30px;">
                                <el-cascader v-model="ruleForm.spare5" clearable
                                    style="width: 100%" collapse-tags :props="props"></el-cascader>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="城市" prop="city_id">
                                <el-select v-model="ruleForm.city_id" style="width:100%" placeholder="请选择" clearable>
                                    <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                        :value="item.city">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="需求人数" prop="demand_amount">
                                <el-input type="number" v-model="ruleForm.demand_amount" placeholder="请输入需求人数"
                                    style="width:100%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支援开始时间" prop="start_date">
                                <el-date-picker v-model="ruleForm.start_date" style="width:100%" type="datetime"
                                    format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支援结束时间" prop="end_date">
                                <el-date-picker v-model="ruleForm.end_date" style="width:100%" type="datetime"
                                    format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支援时长">
                                <el-input v-model="ruleForm.support_duration" placeholder="请输入支援时长" style="width:100%">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支援原因" prop="support_reason">
                                <el-input type="textarea" :rows="2" style="width:100%" placeholder="请输入支援原因"
                                    v-model="ruleForm.support_reason">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label-width="0" style="margin-left: 22%;">
                        <el-button type="goon" @click="AddAuditor()"
                            v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
                        <el-button type="goon" @click="UpdateAuditor()"
                            v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
                        <el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>

            </div>
        </div>

        <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
            :close-on-click-modal="false">
            <SelectAuditor ref="SelectAuditor" :type="3" :examineDetailsList="ruleForm.examineDetailsList"
                :id="ruleForm.id"></SelectAuditor>
        </el-dialog>

    </div>
</template>

<script>
    import SelectAuditor from '../../SelectAuditor/SelectAuditor.vue';
    export default {
        components: {
            SelectAuditor: SelectAuditor,
        },
        props: ["organizeList"],
        data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
            return {
                //表单数据
                ruleForm: {
                    id: '',
                    spare5: '',
                    project_id: '',
                    city_id: '',
                    demand_amount: '',
                    start_date: '',
                    end_date: '',
                    support_duration: '',
                    support_reason: '',
                    examineDetailsList: [],
                },

                //表单验证
                rules: {
                    spare5: [{
                        required: true,
                        message: '请选择组织架构！',
                        trigger: 'blur'
                    }],
                    city_id: [{
                        required: true,
                        message: '请选择城市！',
                        trigger: 'blur'
                    }],
                    demand_amount: [{
                        required: true,
                        message: '请输入人数！',
                        trigger: 'blur'
                    }],
                    start_date: [{
                        required: true,
                        message: '请选择开始时间！',
                        trigger: 'blur'
                    }],
                    end_date: [{
                        required: true,
                        message: '请选择结束时间！',
                        trigger: 'blur'
                    }],
                    support_reason: [{
                        required: true,
                        message: '请输入原因',
                        trigger: 'blur'
                    }],
                },

                //页面相关
                dialogAuditorVisible: false,
                
                //级联下拉配置
                props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
                    value: "id",
                    label: "organize_name",
                    children: "organizeList",
                    checkStrictly: true,
                    multiple: false,
                },

            };
        },
        methods: {
            //添加
            AddAuditor() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.ruleForm.examineDetailsList = [];
                        this.dialogAuditorVisible = true;
                        this.$refs['SelectAuditor'].initialize();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            async Add() {
                var spare5 = "";
                this.ruleForm.spare5.forEach(item => {
                    spare5 += item + ","
                })

                var url = 'supportApply/add';
                var record = {
                    spare5: spare5,
                    project_id: this.ruleForm.project_id,
                    city_id: this.ruleForm.city_id,
                    demand_amount: this.ruleForm.demand_amount,
                    start_date: this.ruleForm.start_date,
                    end_date: this.ruleForm.end_date,
                    support_duration: this.ruleForm.support_duration,
                    support_reason: this.ruleForm.support_reason,
                    examineDetailsList: this.ruleForm.examineDetailsList,
                    applicant_id: this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //修改
            UpdateAuditor() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.ruleForm.examineDetailsList = [];
                        this.dialogAuditorVisible = true;
                        this.$refs['SelectAuditor'].initialize();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            async Update() {
                var spare5 = "";
                this.ruleForm.spare5.forEach(item => {
                    spare5 += item + ","
                })

                var url = 'supportApply/modify';
                var record = {
                    id: this.ruleForm.id,
                    spare5: spare5,
                    project_id: this.ruleForm.project_id,
                    city_id: this.ruleForm.city_id,
                    demand_amount: this.ruleForm.demand_amount,
                    start_date: this.ruleForm.start_date,
                    end_date: this.ruleForm.end_date,
                    support_duration: this.ruleForm.support_duration,
                    support_reason: this.ruleForm.support_reason,
                    examineDetailsList: this.ruleForm.examineDetailsList,
                    applicant_id: this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            Return() {
                this.dialogAuditorVisible = false;
                this.$parent.Return();
            }
        },
        created() {
            this.ruleForm = this.$parent.ruleForm;
        },
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// Gwzysq_add.vue?02e18016